import React, { useState, useEffect } from 'react';
import './App.css';

// Components
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import SimpleHomePage from './pages/SimpleHomePage';
import ProductDevelopmentPage from './pages/ProductDevelopmentPage';
import {Route, Routes} from "react-router-dom";
import ScrollToTop from './ScrollToTop';

// Create a scroll context to share scroll state across components
export const ScrollContext = React.createContext({
  scrollY: 0,
  scrollDirection: 'none'
});

function App() {
  const [scrollY, setScrollY] = useState(0);
  const [scrollDirection, setScrollDirection] = useState('none');
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Determine scroll direction
      if (currentScrollY > lastScrollY) {
        setScrollDirection('down');
      } else if (currentScrollY < lastScrollY) {
        setScrollDirection('up');
      }

      setScrollY(currentScrollY);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  // Add animation on scroll effect
  useEffect(() => {
    const handleScrollAnimation = () => {
      const scrollElements = document.querySelectorAll('.animate-on-scroll');

      scrollElements.forEach(element => {
        const elementPosition = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        if (elementPosition < windowHeight - 100) {
          element.classList.add('animate');
        }
      });
    };

    window.addEventListener('scroll', handleScrollAnimation);
    handleScrollAnimation(); // Initial check

    return () => window.removeEventListener('scroll', handleScrollAnimation);
  }, []);

  return (
      <ScrollContext.Provider value={{ scrollY, scrollDirection }}>
        <div className="App">
          <ScrollToTop/>
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<SimpleHomePage />} />
              <Route path="/home" element={<SimpleHomePage />} />
              <Route path="/product-development" element={<ProductDevelopmentPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </ScrollContext.Provider>
  );
}

export default App;
